import { PriceBreakup } from "src/page/plans/plansSlice";
import internalClient from "../internalClient";
import client from "../client";
import { PaginationRequest } from "src/types/commonTypes";

export type getActiveEntitlementRequest = {
  object_id: string;
  object_type: string;
};

export const getActiveEntitlement = (data: getActiveEntitlementRequest) => {
  return client({
    query: `
      query GetActiveEntitlement($input: GetActiveEntitlementInput) {
        get_active_entitlement(input: $input) {
         organisation_id
          order_id
          entitlement_id
          is_provider_subscription_active
          display_id
          object_id
          object_type
          status
          valid_untill
        }
      }`,
    variables: {
      input: data
    }
  });
};

export type createInternalEntitlementRequest = {
  organisation_id: string;
  object_id: string;
  object_type: string;
  valid_untill: string;
  valid_from: string;
  order_id: string;
  price_attributes: PriceBreakup;
  operated_by: "MANUAL";
};

export const createInternalEntitlement = (data: createInternalEntitlementRequest) => {
  return internalClient({
    query: `
      mutation CreateInternalEntitlement($input: InternalCreateEntitlementInput) {
        internal_create_entitlement(input: $input) {
          entitlement_id
        }
      }
      `,
    variables: {
      input: data
    }
  });
};

export interface getEntitlementRequest extends PaginationRequest {
  filter?: {
    entitlement_filter?: {
      entitlement_ids?: string[];
    };
  };
}

export const getEntitlement = (data: getEntitlementRequest) => {
  return internalClient({
    query: `
    query GetEntitlement($input: SearchInput) {
      internal_search_entitlement(input: $input) {
        total_pages
        total_size
        items {
          organisation_id
          order_id
          entitlement_id
          display_id
          object_id
          object_type
          status
          valid_untill
          valid_from
          operated_by
        }
      }
    }
  `,
    variables: {
      input: data
    }
  });
};

export type updateEntitlementRequest = {
  entitlement_id: string;
  valid_untill: string;
  order_id: string;
  status: "ACTIVE" | "SUSPENDED";
};

export const updateEntitlement = (data: updateEntitlementRequest) => {
  return internalClient({
    query: `
    mutation UpdateEntitlement($input: InternalUpdateEntitlementInput) {
      internal_update_entitlement(input: $input) {
        entitlement_id
      }
    }
  `,
    variables: {
      input: data
    }
  });
};
